<div class="row" *ngIf="loaded">
  <div class="col-12">
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Type</th>
          <th scope="col">Date Created</th>
          <th scope="col">Status</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let d of distributions">
          <td>
            {{ d.name }}
          </td>
          <td>
            {{ d.type }}
          </td>
          <td>
            {{ d.dateCreated }}
          </td>
          <td>
            {{ d.success ? "Success" : "Failure" }}
          </td>
          <td>
            <ng-template [ngIf]="d.success">
              <container-element [ngSwitch]="d.type">
                <span class="fake-link"  *ngSwitchCase="'download'" [routerLink]="" (click)="downloadFile(d)"
                  >Download {{ d.additionalData.fileName }}</span
                >
                <span class="fake-link" *ngSwitchCase="'email'" [routerLink]="" (click)="switchView(d)">View Email</span>
                <span class="fake-link" *ngSwitchCase="'google-chat'" [routerLink]="" (click)="switchView(d)">View Message</span>
              </container-element>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
